package de.emgress.baskets.modules.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.css.marginLeft
import org.jetbrains.compose.web.css.marginRight
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Hr

@Composable
fun Divider() {
    Hr {
        style {
            property("border-top", "1px solid #bbb")
            marginLeft(32.px)
            marginRight(32.px)
        }
    }
}